import AbstractService, {
  InterfacePartnerClient,
  ServicePartnerClient,
  ModelPartnerClient
} from "./AbstractService";

/**
 * AuthService
 */
export default class PartnerClientService extends AbstractService implements InterfacePartnerClient {
  /**
   * ServiceAuth
   */
  static service: ServicePartnerClient;

  /**
   * constructor
   */
  constructor() {
    super();

    PartnerClientService.service = this.getApi().getServicePartnerClient();
  }

  /**
   * create
   * @param PartnerClient
   */
  create(PartnerClient: ModelPartnerClient): Promise<ModelPartnerClient> {
    return PartnerClientService.service.create(PartnerClient);
  }

  /**
   * getById
   * @param id
   * @param type
   */
  getByIdAndType(id: string, type: string): Promise<ModelPartnerClient> {
    return PartnerClientService.service.getByIdAndType(id, type);
  }

  /**
   * update
   * @param id
   * @param PartnerClient
   */
  update(id: string, PartnerClient: ModelPartnerClient): Promise<ModelPartnerClient> {
    return PartnerClientService.service.update(id, PartnerClient);
  }

  /**
   * getAll
   */
  getAll(): Promise<ModelPartnerClient[]> {
    return PartnerClientService.service.getAll();
  }

  /**
   * getDatatable
   */
  getDatatable(tableParameter = {}): Promise<any> {
    return PartnerClientService.service.getDatatable(tableParameter);
  }
}
